import { render } from "./PopUp.vue?vue&type=template&id=587b7cd6"
import script from "./PopUp.vue?vue&type=script&lang=js"
export * from "./PopUp.vue?vue&type=script&lang=js"

import "./PopUp.vue?vue&type=style&index=0&id=587b7cd6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__